import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";

type Props = {
  value: string[];
  onChange: (val: string[]) => void;
  fetchSuggestions?: (q: string) => Promise<string[]>; // optional
};

const filter = createFilterOptions<string>();

const DEFAULT_OPTIONS = [
  "Consultatie",
  "Vaccinare",
  "Microcipare",
  "Deparazitare interna",
  "Deparazitare externa",
  "Sterilizare",
  "Analize laborator",
  "Ecografie",
  "Radiografie",
  "Stomatologie",
  "Internare",
  "Urgente 24/7",
  "Chirurgie",
  "Ortopedie",
  "Dermatologie",
  "Oftalmologie",
  "Oncologie",
  "Cardiologie",
  "Endoscopie",
  "Fizioterapie",
  "Hematologie",
  "Biochimie",
  "Detartraj",
  "Vaccinare antirabica",
  "Vaccinare polivalenta"
];

export default function ServicesField({ value, onChange, fetchSuggestions }: Props) {
  const [options, setOptions] = React.useState<string[]>(DEFAULT_OPTIONS);

  const handleInputChange = async (_: any, input: string) => {
    const q = input.trim();
    if (!q) return;
    if (fetchSuggestions) {
      try {
        const server = await fetchSuggestions(q);
        // dedupe
        const merged = Array.from(new Set([...server, ...DEFAULT_OPTIONS]));
        setOptions(merged);
      } catch {}
    }
  };

  // permite ", ; Enter" ca separatori
  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === "Enter" || e.key === "," || e.key === ";") {
      e.preventDefault();
      const input = (e.target as HTMLInputElement).value.trim();
      if (!input) return;
      const next = Array.from(new Set([...value, input])); // dedupe case-sensitive
      onChange(next);
    }
  };

  return (
    <Autocomplete
      multiple
      freeSolo
      options={options}
      filterOptions={(opts, params) => {
        const filtered = filter(opts, params);
        const { inputValue } = params;
        // sugereaza "Adauga "textul tau""
        const isExisting = opts.some((o) => o.toLowerCase() === inputValue.toLowerCase());
        if (inputValue !== "" && !isExisting) {
          filtered.push(inputValue);
        }
        return filtered;
      }}
      value={value}
      onChange={(_, newValue) => {
        // normalize + dedupe
        const clean = Array.from(
          new Set(
            newValue
              .map((v) => (typeof v === "string" ? v : String(v)))
              .map((s) => s.trim())
              .filter(Boolean)
          )
        );
        onChange(clean);
      }}
      onInputChange={handleInputChange}
      renderTags={(vals, getTagProps) =>
        vals.map((option, index) => (
          <Chip variant="outlined" label={option} {...getTagProps({ index })} key={option} />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Servicii oferite"
          placeholder="Tasteaza si apasa Enter (sau , ; )"
          onKeyDown={handleKeyDown}
          helperText="Separati serviciile cu Enter, virgula sau punct si virgula"
        />
      )}
    />
  );
}
